import { render, staticRenderFns } from "./ds-image.vue?vue&type=template&id=62fdc098&scoped=true"
import script from "./ds-image.vue?vue&type=script&lang=ts"
export * from "./ds-image.vue?vue&type=script&lang=ts"
import style0 from "./ds-image.vue?vue&type=style&index=0&id=62fdc098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdc098",
  null
  
)

export default component.exports